/* eslint-disable prettier/prettier */
import React from "react"
import AOS from "aos"
import CardLeft from "./CardLeft"
import CardRight from "./CardRight"
import style from "./Workshops.module.css"
import "aos/dist/aos.css"
import Workshop1ImagePath from "./img/workshop1.jpg"
import Workshop2ImagePath from "./img/workshop2.jpg"
import Workshop3ImagePath from "./img/workshop3.jpg"
import Workshop4ImagePath from "./img/workshop4.jpg"
import Workshop5ImagePath from "./img/workshop5.jpg"

const Workshops = () => {
  AOS.init({
    duration: 1200,
    offset: 250
  })

  return (
    <div className="bodycontanier">
      <div className={`heading ${style.workshopsHeading}`}>
        <h4>WORKSHOPS</h4>
        <h4>WORKSHOPS</h4>
      </div>
      <div className="container">
        <div className={`workshopIntro ${style.workshopsIntro}`}>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Asperiores
          suscipit dolorem delectus voluptates explicabo voluptas provident,
          nostrum nam deserunt possimus nihil iure, commodi nisi doloribus
          eveniet itaque tenetur tempora totam.
        </div>

        <CardLeft
          imgUrl={Workshop1ImagePath}
          Title="Webinar on Product Management"
          // eventAnim={window.innerWidth <= 420 ? "fade-up" : "fade-left"}
          Description="CSI in association with The Business Club, is elated to present to you a webinar by the masterminds behind this Bible of Product Management- Aditya Agashe & Parth Detroja!.  Aditya Agashe is a Program Manager and works on Azure cloud computing to build hyper-converged and hybrid features that help customers adopt cloud technologies. He previously managed product and engineering teams as the founder of Belle Applications and Head of Product at Speare. Parth is currently a Product Manager at Facebook, where he leads social music product efforts. He has previously worked product management and growth roles at other top tech companies, including Microsoft, Amazon, and IBM.."
        />

        <CardRight
          imgUrl={Workshop2ImagePath}
          Title="3P Workshop"
          // eventAnim={window.innerWidth <= 420 ? "fade-up" : "fade-right"}
          Description="The Club of Sustainability & Innovation (CSI) conducted a 3P (Procure, Product Development, Pitching) workshop on 24th Feb  which covered the basics of pitching and presenting a product in front of a panel of investors with a live case study.
"
        />
        <CardLeft
          imgUrl={Workshop3ImagePath}
          Title="ARDUINO FOR BEGINNERS"
          // eventAnim={window.innerWidth <= 420 ? "fade-up" : "fade-left"}
          Description="The Club of Sustainability and Innovation (CSI) in collaboration with Sapientury (IIM B incubated startup)  conducted a free webinar on *ARDUINO FOR BEGINNERS* to learn crucial inter-disciplinary concepts and build practical skills through hands-on projects based on Arduino!"
        />

        <CardRight
          imgUrl={Workshop4ImagePath}
          Title="Webinar on Web 3.0"
          // eventAnim={window.innerWidth <= 420 ? "fade-up" : "fade-right"}
          Description="CSI, IIT BHU brings you an extraordinary session, “Webinar on Web 3.0,” with Mr Rahul Kolle (Customer Experience@CISCO, Speaker & Storyteller) to cater to all these uncertainties.Mr Rahul is presently compelling stories as a consultant - while helping build deep-tech innovation stories and providing network-critical insights to large enterprises leveraging Cisco solutions.He is deeply passionate about the Art of Business Storytelling & Design Thinking, curating workshops in these domains, and also impacted numerous business leaders globally.
            "
        />
        <CardLeft
          imgUrl={Workshop5ImagePath}
          Title="Session on Getting Yourself Published"
          // eventAnim={window.innerWidth <= 420 ? "fade-up" : "fade-left"}
          Description="CSI conducted an interactive session, 'Getting Yourself Published,' with Ms. Neha Agarwal (Founder, WiseUp Communications & Alumnus, NTU Singapore - the only young university ranked in the Top 15 globally in the last five years).
          Agenda:
          Why scientific writing is important,
          How to organize research article sections, 
          How to write an abstract, 
          What is plagiarism and how to avoid it,
          How to deliver scientific presentations."
        />
      </div>
    </div>
  )
}

export default Workshops
